import { render, staticRenderFns } from "./CommunityPackageInstallModal.vue?vue&type=template&id=d4f5a370&"
import script from "./CommunityPackageInstallModal.vue?vue&type=script&lang=ts&"
export * from "./CommunityPackageInstallModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityPackageInstallModal.vue?vue&type=style&index=0&id=d4f5a370&prod&module=true&lang=scss&"
import style1 from "./CommunityPackageInstallModal.vue?vue&type=style&index=1&id=d4f5a370&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports